__turbopack_context__.v({
  "arrow": "cYZR6W_arrow",
  "arrowFill": "cYZR6W_arrowFill",
  "arrowInnerStroke": "cYZR6W_arrowInnerStroke",
  "arrowOuterStroke": "cYZR6W_arrowOuterStroke",
});
